import { useState, useEffect } from 'react';
import '../styles/HeroSection.css';

const HeroSection = ({ searchTerm, totalPublicaciones, publicacionesFiltradas = [] }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = publicacionesFiltradas
    .filter(p => p.url_portada)
    .slice(0, 5);

  useEffect(() => {
    if (slides.length < 2) return;
    const interval = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  const handleExplore = () => {
    document.querySelector('.cars-grid')?.scrollIntoView({ behavior: 'smooth' });
  };

  const fallbackBg = {
    backgroundImage: `linear-gradient(135deg, #1a3a4f 0%, #2e6a8a 40%, #1e5270 70%, #152d3e 100%)`
  };

  return (
    <section className="hero-section" style={slides.length === 0 ? fallbackBg : {}}>
      {slides.length > 0 ? (
        slides.map((pub, i) => (
          <img
            key={pub.id}
            className={`hero-slide ${i === currentSlide ? 'active' : ''}`}
            src={pub.url_portada}
            alt={pub.titulo}
          />
        ))
      ) : null}

      <div className="hero-overlay" />

      <div className="hero-content">
        <h1 className="hero-title">¿Para qué manejar autos aburridos?</h1>


        {searchTerm?.trim() && (
          <p className="hero-search-info">
            Resultados para: "<strong>{searchTerm}</strong>"
          </p>
        )}

        {!searchTerm?.trim() && (
          <button className="hero-cta" onClick={handleExplore}>
            Explorar todo
          </button>
        )}
      </div>

      {slides.length > 1 && (
        <div className="hero-dots">
          {slides.map((_, i) => (
            <button
              key={i}
              className={`hero-dot ${i === currentSlide ? 'active' : ''}`}
              onClick={() => setCurrentSlide(i)}
              aria-label={`Slide ${i + 1}`}
            />
          ))}
        </div>
      )}
    </section>
  );
};

export default HeroSection;
